import React from 'react';
import { Helmet } from 'react-helmet-async';
import { sendGAPageview } from '../utils/gaConsent';
import CommonHeader from '../Components/Headers/CommonHeader';
import CookieContent from '../Components/Cookies/CookieContent';
import CookiesNav from '../Components/Cookies/CookiesNav';
import $ from 'jquery';

export default function CookiesPolicy() {
  $('.popover').hide();
  sendGAPageview({
    hitType: 'pageview',
    page: '/Cookies-policy',
    title: 'Cookies policy',
  });

  return (
    <React.Fragment>
      <Helmet>
              <title>DISGENET: Cookies Policy</title>
              <meta
                name="description"
                content=""
              />
      
              {/* Open Graph Tags for LinkedIn */}
              <meta property="og:type" content="website" />
              <meta property="og:url" content="https://www.disgenet.com/Cookies-policy" />
              <meta property="og:title" content="DISGENET: Cookies Policy" />
              <meta
                property="og:description"
                content="This policy describes the cookies used by MedBioinformatics Solutions S.L (hereinafter, “MedBio”, the “Company”, or “we/us”)"
              />
            </Helmet>
      <CommonHeader />
      <section>
        <link rel="canonical" href="/Cookies-policy" />
        <div className="container txt-contenido">
          <h2 className="mt-8">Cookies Policy</h2>
      <CookiesNav />
      <CookieContent />
      </div>
      </section>
    </React.Fragment>
  );
}
